// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/react-scripts/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./assets/side-bar-2.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* .MuiButton-root {
    background-color: green;
    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);
    padding: 7px 14px;
  }
  .MuiButton-root:hover {
    background-color: green;
  }
  .MuiButton-label {
    color: #fff;
  } */


  
.css-y3vmdp {
  
    width: 250px !important;
    object-fit: cover;
}

.css-1ff53da {
  margin: 0.75rem 0.5rem 0.5rem 0.5rem !important;
}

.css-8atqhb {

  height: 65px;
  background-color: #fff;
} 

  .MuiList-root {
    background: '#404e67h';
    padding-top: 5px !important;
  }

  .css-33ehgt-MuiPaper-root-MuiAppBar-root {
    box-shadow: none !important
  }


/* Typography uses the active MUI theme and component colors. */

.MuiDataGrid-root-columnHeaderRow {
    background: #404e67;
}
/* 
.MuiDrawer-root {
    
    background-color: #404e67;
}

.MuiBox-root {
    
    background-color: #f0f0f0;
} 

.css-1w9rki-MuiDrawer-docked .MuiDrawer-paper{
    background-color: #404e67;

} */

.css-ggbs2o-MuiDrawer-docked .MuiDrawer-paper {
  color: #33B0FF;
  background-color: #21295C;

  background-image: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0.75) 0%,
    rgba(31, 30, 30, 0.75) 40%,
    rgba(20, 19, 19, 0.5) 100%
  ),
  url(${___CSS_LOADER_URL_REPLACEMENT_0___});

  background-repeat: no-repeat;
  background-position: center;
  background-size: 800px 1107px;

  width: 250px;
  height: 100vh;
}

/* Hover effect */
.MuiListItemButton-root:hover {
  color: #ffffff;   /* clear hover color */
  background-color: rgba(51, 176, 255, 0.2);
}



.css-1w9rki-MuiDrawer-docked .MuiDrawer-paper {
    display: block;
    background-color: #404e67 !important;
}

.css-1yo9slo-MuiToolbar-root {
    min-height: 64px;
    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.12) !important;;
    /* background-color: #fff !important; */
}

.css-1k0fm33-MuiSvgIcon-root {

    color: #fff;
}
.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,
.react-datepicker__month-text--selected,
.react-datepicker__month-text--in-selecting-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--selected,
.react-datepicker__quarter-text--in-selecting-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--selected,
.react-datepicker__year-text--in-selecting-range,
.react-datepicker__year-text--in-range {
  /* border-radius: 1.3rem; */
  background-color: transparent;
  color: #000;
}
.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,
.react-datepicker__month-text--selected:hover,
.react-datepicker__month-text--in-selecting-range:hover,
.react-datepicker__month-text--in-range:hover,
.react-datepicker__quarter-text--selected:hover,
.react-datepicker__quarter-text--in-selecting-range:hover,
.react-datepicker__quarter-text--in-range:hover,
.react-datepicker__year-text--selected:hover,
.react-datepicker__year-text--in-selecting-range:hover,
.react-datepicker__year-text--in-range:hover {
  background-color: transparent;
  /* border-radius: 1.3rem; */
  /* background-color: green; */
}
.react-datepicker__day--selected:hover,.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover{
  background-color: #33B0F7;
}
.react-datepicker-popper {
    z-index: 50;
  }
.react-datepicker__year-read-view--down-arrow,
.react-datepicker__month-read-view--down-arrow,
.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {
  border-color: #33B0F7;
  border-style: solid;
  border-width: 3px 3px 0 0;
  content: "";
  display: block;
  height: 9px;
  position: absolute;
  top: 17px;
  width: 9px;
}
.react-datepicker__day--keyboard-selected,
.react-datepicker__month-text--keyboard-selected,
.react-datepicker__quarter-text--keyboard-selected,
.react-datepicker__year-text--keyboard-selected {
  /* border-radius: 1.3rem; */
  /* background-color: #33B0F7; */
  background-color: transparent;
  color: #000;
}
.react-datepicker__navigation:hover *::before {
  border-color: #DBDADA;
}
.hover:focus{
  outline: none;
}
.react-datepicker__current-month,
.react-datepicker-time__header,
.react-datepicker-year-header {
  margin-top: 0;
  color: #0A0909;
  font-weight: bold;
  font-size: 0.944rem;
  padding: 5px;
  /* border: 1px solid #404E67; */
}
.social-media{
}
.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range),
.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,
.react-datepicker__month-text--in-range,
.react-datepicker__quarter-text--in-range,
.react-datepicker__year-text--in-range) {
  background-color: transparent;
}

.react-tel-input .country-list {
  background-color: #f0f0f0 !important;
  color: black !important;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 9999;
  max-height: 200px;
  overflow-y: auto;
}

body.dark .react-tel-input .flag-dropdown.open ul.country-list {
  background-color: #9ea6eb !important;
  color: white !important;
}
.react-tel-input .country-list .country {
  display: flex !important;
  justify-content: space-between !important;
  align-items: center;
  padding-left: 45px !important;
  /* padding-right: 12px !important; */
  width: 100% !important;
  box-sizing: border-box;
}


/* Remove hover border for input */
.react-tel-input .form-control:hover {
  border: none !important;
  box-shadow: none !important;
}

/* Remove hover background for the flag dropdown button */
.react-tel-input .flag-dropdown:hover {
  background-color: inherit !important;
  border: none !important;
}

/* Optional: remove hover outline */
.react-tel-input .form-control:focus,
.react-tel-input .form-control:active {
  outline: none !important;
  box-shadow: none !important;
}

`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAAA;;;;;;;;;;KAUK;;;;AAIL;;IAEI,uBAAuB;IACvB,iBAAiB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;;EAEE,YAAY;EACZ,sBAAsB;AACxB;;EAEE;IACE,sBAAsB;IACtB,2BAA2B;EAC7B;;EAEA;IACE;EACF;;;AAGF,+DAA+D;;AAE/D;IACI,mBAAmB;AACvB;AACA;;;;;;;;;;;;;;GAcG;;AAEH;EACE,cAAc;EACd,yBAAyB;;EAEzB;;;;;;yCAM8B;;EAE9B,4BAA4B;EAC5B,2BAA2B;EAC3B,6BAA6B;;EAE7B,YAAY;EACZ,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,cAAc,IAAI,sBAAsB;EACxC,yCAAyC;AAC3C;;;;AAIA;IACI,cAAc;IACd,oCAAoC;AACxC;;AAEA;IACI,gBAAgB;IAChB,oIAAoI;IACpI,uCAAuC;AAC3C;;AAEA;;IAEI,WAAW;AACf;AACA;;;;;;;;;;EAUE,2BAA2B;EAC3B,6BAA6B;EAC7B,WAAW;AACb;AACA;;;;;;;;;;EAUE,6BAA6B;EAC7B,2BAA2B;EAC3B,6BAA6B;AAC/B;AACA;EACE,yBAAyB;AAC3B;AACA;IACI,WAAW;EACb;AACF;;;EAGE,qBAAqB;EACrB,mBAAmB;EACnB,yBAAyB;EACzB,WAAW;EACX,cAAc;EACd,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;AACA;;;;EAIE,2BAA2B;EAC3B,+BAA+B;EAC/B,6BAA6B;EAC7B,WAAW;AACb;AACA;EACE,qBAAqB;AACvB;AACA;EACE,aAAa;AACf;AACA;;;EAGE,aAAa;EACb,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,+BAA+B;AACjC;AACA;AACA;AACA;;;;;;;;;;;;;;;;EAgBE,6BAA6B;AAC/B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;AACA;EACE,wBAAwB;EACxB,yCAAyC;EACzC,mBAAmB;EACnB,6BAA6B;EAC7B,oCAAoC;EACpC,sBAAsB;EACtB,sBAAsB;AACxB;;;AAGA,kCAAkC;AAClC;EACE,uBAAuB;EACvB,2BAA2B;AAC7B;;AAEA,yDAAyD;AACzD;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA,mCAAmC;AACnC;;EAEE,wBAAwB;EACxB,2BAA2B;AAC7B","sourcesContent":["/* .MuiButton-root {\n    background-color: green;\n    box-shadow: 0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08);\n    padding: 7px 14px;\n  }\n  .MuiButton-root:hover {\n    background-color: green;\n  }\n  .MuiButton-label {\n    color: #fff;\n  } */\n\n\n  \n.css-y3vmdp {\n  \n    width: 250px !important;\n    object-fit: cover;\n}\n\n.css-1ff53da {\n  margin: 0.75rem 0.5rem 0.5rem 0.5rem !important;\n}\n\n.css-8atqhb {\n\n  height: 65px;\n  background-color: #fff;\n} \n\n  .MuiList-root {\n    background: '#404e67h';\n    padding-top: 5px !important;\n  }\n\n  .css-33ehgt-MuiPaper-root-MuiAppBar-root {\n    box-shadow: none !important\n  }\n\n\n/* Typography uses the active MUI theme and component colors. */\n\n.MuiDataGrid-root-columnHeaderRow {\n    background: #404e67;\n}\n/* \n.MuiDrawer-root {\n    \n    background-color: #404e67;\n}\n\n.MuiBox-root {\n    \n    background-color: #f0f0f0;\n} \n\n.css-1w9rki-MuiDrawer-docked .MuiDrawer-paper{\n    background-color: #404e67;\n\n} */\n\n.css-ggbs2o-MuiDrawer-docked .MuiDrawer-paper {\n  color: #33B0FF;\n  background-color: #21295C;\n\n  background-image: linear-gradient(\n    to bottom,\n    rgba(0, 0, 0, 0.75) 0%,\n    rgba(31, 30, 30, 0.75) 40%,\n    rgba(20, 19, 19, 0.5) 100%\n  ),\n  url(\"./assets/side-bar-2.png\");\n\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 800px 1107px;\n\n  width: 250px;\n  height: 100vh;\n}\n\n/* Hover effect */\n.MuiListItemButton-root:hover {\n  color: #ffffff;   /* clear hover color */\n  background-color: rgba(51, 176, 255, 0.2);\n}\n\n\n\n.css-1w9rki-MuiDrawer-docked .MuiDrawer-paper {\n    display: block;\n    background-color: #404e67 !important;\n}\n\n.css-1yo9slo-MuiToolbar-root {\n    min-height: 64px;\n    box-shadow: 0px 2px 4px -1px rgba(0, 0, 0, 0.2), 0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 1px 0px rgba(0, 0, 0, 0.12) !important;;\n    /* background-color: #fff !important; */\n}\n\n.css-1k0fm33-MuiSvgIcon-root {\n\n    color: #fff;\n}\n.react-datepicker__day--selected, .react-datepicker__day--in-selecting-range, .react-datepicker__day--in-range,\n.react-datepicker__month-text--selected,\n.react-datepicker__month-text--in-selecting-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--selected,\n.react-datepicker__quarter-text--in-selecting-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--selected,\n.react-datepicker__year-text--in-selecting-range,\n.react-datepicker__year-text--in-range {\n  /* border-radius: 1.3rem; */\n  background-color: transparent;\n  color: #000;\n}\n.react-datepicker__day--selected:hover, .react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover,\n.react-datepicker__month-text--selected:hover,\n.react-datepicker__month-text--in-selecting-range:hover,\n.react-datepicker__month-text--in-range:hover,\n.react-datepicker__quarter-text--selected:hover,\n.react-datepicker__quarter-text--in-selecting-range:hover,\n.react-datepicker__quarter-text--in-range:hover,\n.react-datepicker__year-text--selected:hover,\n.react-datepicker__year-text--in-selecting-range:hover,\n.react-datepicker__year-text--in-range:hover {\n  background-color: transparent;\n  /* border-radius: 1.3rem; */\n  /* background-color: green; */\n}\n.react-datepicker__day--selected:hover,.react-datepicker__day--in-selecting-range:hover, .react-datepicker__day--in-range:hover{\n  background-color: #33B0F7;\n}\n.react-datepicker-popper {\n    z-index: 50;\n  }\n.react-datepicker__year-read-view--down-arrow,\n.react-datepicker__month-read-view--down-arrow,\n.react-datepicker__month-year-read-view--down-arrow, .react-datepicker__navigation-icon::before {\n  border-color: #33B0F7;\n  border-style: solid;\n  border-width: 3px 3px 0 0;\n  content: \"\";\n  display: block;\n  height: 9px;\n  position: absolute;\n  top: 17px;\n  width: 9px;\n}\n.react-datepicker__day--keyboard-selected,\n.react-datepicker__month-text--keyboard-selected,\n.react-datepicker__quarter-text--keyboard-selected,\n.react-datepicker__year-text--keyboard-selected {\n  /* border-radius: 1.3rem; */\n  /* background-color: #33B0F7; */\n  background-color: transparent;\n  color: #000;\n}\n.react-datepicker__navigation:hover *::before {\n  border-color: #DBDADA;\n}\n.hover:focus{\n  outline: none;\n}\n.react-datepicker__current-month,\n.react-datepicker-time__header,\n.react-datepicker-year-header {\n  margin-top: 0;\n  color: #0A0909;\n  font-weight: bold;\n  font-size: 0.944rem;\n  padding: 5px;\n  /* border: 1px solid #404E67; */\n}\n.social-media{\n}\n.react-datepicker__day--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__month-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__quarter-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range),\n.react-datepicker__year-text--in-selecting-range:not(.react-datepicker__day--in-range,\n.react-datepicker__month-text--in-range,\n.react-datepicker__quarter-text--in-range,\n.react-datepicker__year-text--in-range) {\n  background-color: transparent;\n}\n\n.react-tel-input .country-list {\n  background-color: #f0f0f0 !important;\n  color: black !important;\n  border-radius: 8px;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n  z-index: 9999;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\nbody.dark .react-tel-input .flag-dropdown.open ul.country-list {\n  background-color: #9ea6eb !important;\n  color: white !important;\n}\n.react-tel-input .country-list .country {\n  display: flex !important;\n  justify-content: space-between !important;\n  align-items: center;\n  padding-left: 45px !important;\n  /* padding-right: 12px !important; */\n  width: 100% !important;\n  box-sizing: border-box;\n}\n\n\n/* Remove hover border for input */\n.react-tel-input .form-control:hover {\n  border: none !important;\n  box-shadow: none !important;\n}\n\n/* Remove hover background for the flag dropdown button */\n.react-tel-input .flag-dropdown:hover {\n  background-color: inherit !important;\n  border: none !important;\n}\n\n/* Optional: remove hover outline */\n.react-tel-input .form-control:focus,\n.react-tel-input .form-control:active {\n  outline: none !important;\n  box-shadow: none !important;\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
